module.exports = __webpack_public_path__ + "img/dz.4e0683de.svg";